import Popup from "reactjs-popup";
import ArticleMobilePreview from "../../data-parsing/articles/MobilePreview";
import { Article } from "../../data-parsing/articles/Article";
import { DeviceFrameset } from "react-device-frameset";
import DraggableScrollDiv from "../draggableScroll/DraggableScrollDiv";
import { confirmAlert } from "react-confirm-alert";
import { useRef } from "react";
import { Video } from "../../data-parsing/videos/Video";
import VideoMobilePreview from "../../data-parsing/videos/MobilePreview";
import { Podcast } from "../../data-parsing/podcasts/Podcast";
import PodcastMobilePreview from "../../data-parsing/podcasts/MobilePreview";
import ProductMobilePreview from "../../data-parsing/products/MobilePreview";
import { Product } from "../../data-parsing/products/Product";

export default function MobilePreviewPopUp({ trigger, data, ...other }) {
  const handleSubmitRef = useRef();

  const previewContent = () => {
    switch (other?.dataTemplate) {
      case Article:
        return (
          <ArticleMobilePreview
            article={data}
            handleSubmitRef={handleSubmitRef}
          />
        );
      case Video:
        return (
          <VideoMobilePreview video={data} handleSubmitRef={handleSubmitRef} />
        );
      case Podcast:
        return (
          <PodcastMobilePreview
            podcast={data}
            handleSubmitRef={handleSubmitRef}
          />
        );

      case Product:
        return (
          <ProductMobilePreview
            product={data}
            handleSubmitRef={handleSubmitRef}
          />
        );
    }
  };

  return (
    <Popup trigger={trigger} modal closeOnDocumentClick={false}>
      {(close) => (
        <DeviceFrameset
          device="iPhone X"
          color="gold"
          style={{ overflowY: "auto" }}
        >
          <DraggableScrollDiv
            className={"mobile-preview m-l-5 m-r-5 pt-20 pb-25"}
            style={{ height: "100%" }}
          >
            <i
              onClick={close}
              className="fas fa-times"
              style={{
                float: "right",
                fontSize: "25px",
                cursor: "pointer",
                marginRight: "10px",
                marginTop: "-15px",
              }}
            />

            {previewContent(close)}

            <button
              onClick={() =>
                confirmAlert({
                  title: "Esta acción no se puede deshacer",
                  message: "¿Quieres guardar los cambios realizados?",
                  buttons: [
                    {
                      label: "Guardar y salir",
                      onClick: () => {
                        handleSubmitRef.current?.submit();
                        close();
                      },
                    },
                    {
                      label: "Salir sin guardar",
                      onClick: () => {
                        close();
                      },
                    },
                    {
                      label: "Cancelar",
                    },
                  ],
                })
              }
            >
              Guardar cambios
            </button>
          </DraggableScrollDiv>
        </DeviceFrameset>
      )}
    </Popup>
  );
}
